import React, { useEffect, useState } from 'react'
import styles from '../../styles/casestudy.module.css'
import Image from 'next/image'
import TestimonialSection from '../common/TestimonialSection'
import { testimonialData, videoTestimonial } from '@/constants/common'
import content from '../../language/ENGLISH.json'
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner'
import VerificationPopup from '../modals/VerificationPopup'
import TrustFactor from '../common/TrustFactor'
import FrequentQuestions from '../homePage/FrequentQuestions'
import { useRouter } from 'next/router'
import MobileTestimonialSection from '../common/MobileTestimonialSection'
import FAQ_mobile from '../Industry/FAQ_mobile'
import MobilePDBanner from '../common/MobilePDBanner'
import { headers } from 'next.config'

const CocoCart = () => {
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const router = useRouter()

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const engagementSnap = [
        {
            title: <>  Implemented In<b> 1 Location</b><br /> Over  <b>2 Weeks</b></>,
            tag: "Pilot Phase",
            tagColor: "#C9F6FF",
            bgColor: "#EDFBFE",
            width: "44%",
            mobileWidth: "48%"
        },
        {
            title: <> <b>30 Minutes</b></>,
            tag: "Rollout Phase",
            tagColor: "#F8D378",
            bgColor: "#FFF6E4",
            width: "54%",
            mobileWidth: "49%"
        },
        {
            title: <><b>2 Seamless</b> Integration </>,
            tag: "Integrations",
            tagColor: "#87F1D5",
            bgColor: "#EDFEF9",
            width: "54%",
            mobileWidth: "48%"
        },
        {
            title: <><b>3 Weeks </b>  </>,
            tag: "Outcome",
            tagColor: "#EEC9FF",
            bgColor: "#FCF7FF",
            width: "44%",
            mobileWidth: "49%"
        }
    ]

    const qbPOS = [
        {
            title: "RealTime Insights",
            description: "Real-time visibility and insights for better decision-making.",
            icon: "/assets/caseStudy/hul/realtime-insights.svg"
        },
        {
            title: "Robust Software",
            description: "A powerful, flexible solution tailored for complex supply chains.",
            icon: "/assets/caseStudy/hul/robust-software.svg"
        },
        {
            title: "Seamless integration",
            description: "Smaff integration with your current systems to ensure operations are done without hitches.",
            icon: "/assets/caseStudy/hul/integration.svg"
        },
        {
            title: "Exceptional Support",
            description: "A dedicated customer support team to ensure operations are done seamlessly.",
            icon: "/assets/caseStudy/hul/support.svg"
        },
    ]
    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    How did QueueBuster POS help HUL achieve real-time visibility of SKU movements?
                </span>
            ),
            des: "It automated sub-stockist automation with QueueBuster POS, having a full-proof end-to-end tracking system that gives real-time visibility into the movements of SKUs. It was rolled out in over 4,000 sub-stockists, which helped HUL trace the movement of goods, starting from the distributor, up to the sub-stockists, and then toward the Kirana stores. The system flawlessly integrated with HUL's existing ICT infrastructure, and thus was in a position to capture and report real-time data and information directly. It is in this regard that HUL was able to view how shifts were fairing in terms of stock management and consequently replenishment, making an extra effort to respond promptly to the needs dictated by changes in demand so that products were where they were needed. Such visibility in real time was absolutely important for accurate forecasting and, as such, strategic planning in a bid to realize improved sales as well as customer service.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What specific challenges did HUL face before implementing QueueBuster POS?
                </span>
            ),
            des: "Before the implementation of QueueBuster POS, HUL had very limited visibility on the tertiary channels of supply. This lack of transparency made it impossible for the company to trace the movement of its SKUs beyond the distributor level. The result was frequent stock outs, over stockings, inefficiencies in inventory management, and demand forecasting. Quick insights into the consumption pattern across regions had always posed a challenge for HUL, hampering its ability to plan and strategize the execution of its marketing strategies. Without an effective tracking mechanism, the inability to correlate operational inputs and results further precipitated an overall poor business performance.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How did QueueBuster POS address the integration needs of HUL's existing systems?
                </span>
            ),
            des: "The architecture of the QueueBuster POS system was such that it could easily integrate with all previous systems of HUL, providing minimal or no disturbance at the time of deployment. The integration process had nine different touchpoints to connect QueueBuster POS to the existing HUL infrastructure. Integration was such that it was able to pass real-time data between QueueBuster POS and the HUL ERP system to synchronize inventory updates, automate order processing, and centralize reporting. The team coordinated with HUL to accommodate the company's requirements regarding data formats, communication protocols, and security in order to guarantee a smooth transition that helped the company run its business operations more efficiently.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    When was QueueBuster POS deployed, and what was the way it was rolled out?
                </span>
            ),
            des: "QueueBuster POS was deployed for HUL in two phases. We had the pilot phase of 100 sub-stockists that took three weeks. This was an important step to test whether the system could sustain its functionality and meet HUL's expectations. Once pilot went off successfully it was rolled out to over 4000+ sub-stockists within a period of six weeks. The whole program was honestly well planned and managed to minimize any disruptions. A team from QueueBuster worked closely with the HUL staff in providing training means, support activities, and troubleshooting to ensure that things went smooth. The integrations and system adjustments took eight weeks from end to end.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Which features of QueueBuster POS drove the project's success?
                </span>
            ),
            des: "There were several key features of QueueBuster POS that had a great bearing on the success of HUL's sub-stockists automation project. These features covered real-time SKU tracking that allowed immediate visibility in the movement of products, automated inventory management to reduce manual errors and to increase stock accuracy, and comprehensive reporting tools to provide actionable insights into the sales and consumption pattern. In addition, the scalability of the system was huge enough to withstand the large volume of data produced by more than 4,000 sub-stockists, and its user-friendly interface made it easy for the sub-stockists to adapt and use with great effect. A little more configurational robustness and interfacing capability of QueueBuster POS had ensured flawless communication with the existing systems of HUL, and hence their operational efficiency kept on increasing.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How did QueueBuster POS improve business planning and forecasting for HUL?
                </span>
            ),
            des: "QueueBuster POS provided a good effect in business planning and forecasting facilities for HUL through the real-time availability of data on the movement of SKUs and inventory levels, respectively. Accurate and up-to-date information on the availability of stock items, consumption trends, and the like could enable HUL to undertake well-informed decisions on production schedules, distribution strategies and the perfect tagline and approach for marketing campaigns. HUL could use its exhaustive reporting tools to cull sales data on the various regions and product categories, analyze them for patterns and trends, and course-correct their plans accordingly. This enhanced the visibility and actionable transparency of data for HUL to optimize the supply chain processes and reduce wastages, ensuring that products were available at any point to serve the customer demand.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What was the kind of support that QueueBuster provided both during and after deployment?
                </span>
            ),
            des: "QueueBuster provided total support throughout deployment as well as post-deployment. In the implementation stage, a dedicated project team worked with HUL to ensure the right setup of the system and integration points were working as required. The team also trained the HUL and sub-stockists' staff on-site in order to bring them up to speed in using the new system. QueueBuster continued to offer support after deployment through a dedicated helpdesk available to address any issues or questions. Regular system updates and maintenance kept QueueBuster POS relevant to the ongoing operational needs of HUL.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How did HUL's sub-stockists respond to the implementation of QueueBuster POS?
                </span>
            ),
            des: "The response from HUL's sub-stockists to the implementation of QueueBuster POS was overwhelmingly positive. The user-friendly interface and intuitive design of this system is very easy to adapt to sub-stockists. They liked automated inventory management and real-time tracking features, which were very useful in saving time and reducing the effort involved in stock checks and record-keeping. The system also offered increased visibility into their own operations, letting them manage their inventory effectively and respond with improved swiftness to change in demand. On the whole, QueueBuster POS accomplished increased efficiency and productivity for HUL's sub-stockists.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What metrics would evaluate the success of the QueueBuster POS deployment for HUL?
                </span>
            ),
            des: "The metrics against which the success of QueueBuster POS deployment for HUL would be measured include the accuracy and timeliness in tracking all SKUs, improvement in the efficiency of inventory management, and the ebullition of stock-out and overstock situations. Some other of the key metrics were the velocity of integration; effectiveness with HUL's existing system; duration of deployment; and level of user adoption and user satisfaction in the channel of the sub-stockists. HUL used to measure the overall effect of the system on their business performance: increased sales, improved levels of customer satisfaction, and a higher level of accuracy in business planning and forecasting.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What are HUL's plans to further deploy QueueBuster POS?
                </span>
            ),
            des: "Given the success of the pilot rollout, HUL has future plans to further extend the use of QueueBuster POS within their broader supply chain. This would mean extending the system to other sub-stockists as well as incorporating it into more aspects of their operations. The company is also considering the possibility of using QueueBuster POS to keep an eye on and manage other parts of its supply chain, including production and distribution processes. Further, HUL is eyeing the way advanced analytics and machine learning capabilities will be implemented to give more insight into data captured by QueueBuster POS, further sharpening its business planning and decision-making processes.",
            id: 10,
            activeIndex: 0,
        },
    ]
    const BusinessInsights=[
        {
            image:"/assets/caseStudy/irctc/heineken.webp",
            header:"Case Study",
            title:"BreathingRoom achieves shorter sales cycle and faster revenue realisation with Razorpay.",
            text:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore ",
        },
        {
            image:"/assets/caseStudy/irctc/mobile-hero-img.webp",
            header:"Case Study",
            title:"BreathingRoom achieves shorter sales cycle and faster revenue realisation with Razorpay.",
            text:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore ",
        },
        {
            image:"/assets/caseStudy/irctc/mobile-hero-img.webp",
            header:"Blog",
            title:"BreathingRoom achieves shorter sales cycle and faster revenue realisation with Razorpay.",
            text:"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore ",
        }
    ]
    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section}>
                {
                    mobileView ?
                        <div className={styles.mobile_hero_img} style={{ backgroundImage: "url('/assets/caseStudy/cocoCart/mobile_cocoCart_hero_img.webp')" }}>
                            <div>
                                <h1>How <span className={styles.blue_text}>QueueBuster</span> Transformed One Store into 65</h1>
                                <div className={styles.hero_content}>
                                    <div>
                                        <p>65+</p>
                                        <p>Stores</p>
                                    </div>
                                    <div>
                                        <p>4x</p>
                                        <p>Faster Billing</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className={styles.hero_section_inner_container}>
                            <div className={styles.hero_section_image}><Image src="/assets/caseStudy/cocoCart/cocoCart_hero_img.webp" alt="irctc hero image" fill /></div>
                            <div className={styles.hero_heading1}><h1>How QueueBuster POS Transformed One Store into 65</h1></div>
                            <div className={styles.hero_content}>
                                <div>
                                    <p>65+</p>
                                    <p>Stores</p>
                                </div>
                                <div>
                                    <p>4x</p>
                                    <p>Faster Billing</p>
                                </div>
                                <div>
                                    <p>100%</p>
                                    <p>Error Free Transactions</p>
                                </div>
                            </div>
                        </div>
                }
                <div className={styles.light_blue_box}>
                    <div>
                        <p>About Cococart</p>
                        <p>Cococart is India's leading omnichannel retailer and the official distributor for a wide variety of imported chocolates. With premium offerings and expansive reach, Cococart has sealed its position as the go-to destination for chocolate enthusiasts across India.</p>
                    </div>
                    <div>
                        <p>Deployed Solution</p>
                        <p>QueueBuster turned out to be the perfect solution, as it is the only POS software in India that can serve both requirements. QueueBuster rolled out successfully across more than 100 Cococart stores all over India, providing a robust ERPgrade solution that runs seamlessly on their existing Android devices. This integration with Microsoft Navision provided for smooth backend inventory management. QueueBuster became an extremely important tool for Cococart. <br /><br />

                           QueueBuster has been able to provide Cococart with the platform to upgrade its operations, cut down on rising costs, and achieve better utilization of space from its network of retail outlets. This case study very astutely portrays how state-of-the-art technology solutions can resolve unique business challenges and engender growth in competitive markets.
                        </p>
                    </div>
                </div>
                <div className={styles.owner_words}>
                    <p>"We discovered the capabilities of QueueBuster while evaluating them for an inflight retail solution. QueueBuster turned out to be the best choice for Cococart given the specific requirements we had. Their amazing tech support is the icing on the cake."</p>
                    <p className={styles.name}> Mr. Mandar</p>
                    <p className={styles.position}> Vice President of Information Systems, Cococart</p>
                </div>
            </div >
            <div className={styles.section_two}>
                <div>
                    <div className={styles.problem_statement}>
                        <p className={styles.orange_heading}>Problem Statement</p>
                        <p>Felling a competitive need to keep pace with retail competitors for the sale of chocolate, Cococart needed a POS software solution that could be easily bundled to run on existing Android-based card swiping machines. Additionally, integration to Microsoft Navision was necessary to support efficient management of backend inventory at headquarters. Traditional legacy Windows-based POS systems were not an option, due to real estate constraints and cost alone.</p>
                        <p className={styles.green_heading}>Outcomes</p>
                        <p>With QueueBuster, Cococart was able to bypass the traditional constraints of POS systems: mainly taking up a lot of shelf space and being more expensive. In addition to having smooth operations at Cococart, QueueBuster provided it with a strong cost-effective solution to compete at par with expensive, space-consuming systems.</p>
                    </div>
                    <div className={styles.blue_box}>
                        <div className={styles.client_img}><Image src="/assets/caseStudy/cocoCart/CococartLogo.svg" alt="irctc" fill /></div>
                        {/* <div className={styles.row}>
                            <p className={styles.light_heading}>Industry Type</p>
                            <p>D2C</p>
                        </div> */}
                        <div className={styles.row} style={{ display: "flex", gap: "3rem" }}>
                         
                            <div>
                                {/* <p className={styles.light_heading}>Type of Business</p> 
                                <p>Hospitality</p> */}
                                <p className={styles.light_heading}>Industry Type</p>
                                <p>D2C</p>
                            </div>
                            <div>
                                <p className={styles.light_heading}>Number of Stores</p>
                                <p>65+</p>
                            </div>
                        </div>
                        <div className={styles.row}>
                            <p className={styles.block}>Billing</p>
                            <p className={styles.block}>Inventory Management</p>
                            <p className={styles.block}>Online & Offline Store Management</p>
                            <p className={styles.block}>Dynamics 365 Business Central</p>
                            <p className={styles.block}>ADSR</p>
                        </div>
                    </div>
                </div>
                <div>
                    <p className={styles.pink_heading}>Engagement Snapshot</p>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
                        {
                            engagementSnap?.map((ele) => {
                                return (
                                    <div style={{ backgroundColor: ele?.bgColor, width: mobileView ? ele?.mobileWidth : ele?.width, padding: mobileView ? "1.5rem" : "3.75rem", borderRadius: "1rem" }}>
                                        <p style={{ font: mobileView ? "normal normal normal 1.8rem/3rem Inter" : "normal normal normal 2.4rem/3rem Inter" }}>{ele?.title}</p>
                                        <div style={{ backgroundColor: ele?.tagColor, padding: "1rem 2rem", borderRadius: "70px", width: "fit-content", marginTop: "2rem" }}>{ele?.tag}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            <div className={styles.qb_POS}>
                <h3>Why Choose QueueBuster POS?</h3>
                <div className={styles.qb_POS_container}>
                    {
                        qbPOS?.map((ele) => {
                            return (
                                <div>
                                    <div style={{ height: "5rem", width: "5rem", position: "relative", margin: "2rem auto" }}><Image src={ele?.icon} alt={ele?.title} fill /></div>
                                    <p style={{ font: "normal normal 500 1.8rem/2.6rem Inter", textAlign: "center" }}>{ele?.title}</p>
                                    <p style={{ font: "normal normal normal 1.4rem/2rem Inter", textAlign: "center", color: "#6F7F96" }}>{ele?.description}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className={styles.supply_chain}>
                <div>
                    <h4>Transform Your Supply Chain with QueueBuster POS</h4>
                    <p>QueueBuster POS is dedicated to providing innovative solutions that streamline operations, and enhance visibility across the supply chain, and with our powerful software, businesses like HUL are able to maintain better planning, forecasting, and overall efficiency.</p>
                </div>
                <div style={{ height: mobileView ? "15rem" : "20rem", width: mobileView ? "27rem" : "35rem", position: "relative" }}><Image src="/assets/caseStudy/hul/supply_chain.webp" alt="upply Chain with QueueBuster POS" fill /></div>
            </div> <br />

            {/* <div>
                <div className={styles.section_heading}><h3>Transform Your Supply Chain with QueueBuster POS</h3> <div className={styles.heading_stroke}></div> <Image src="" fill alt='/assets/'/></div>
                
                <div className={styles.BusinessInsights_container} >
                {    
                BusinessInsights.map((ele, index) => (
                    <div key={index} >
                        <div  className={styles.BusinessInsights_image}  style={{ backgroundImage: `url(${ele.image})` }} >
                        


                        <div className={styles.BusinessInsights_content}>
                            <p>{ele.header}</p>
                            <p>{ele.title}</p>
                            <p>{ele.text}</p>
                            <div className={styles.ViewCaseStudy}><p>View Case Study</p> <div className={styles.arrow_outward}><Image src='/assets/caseStudy/arrow_outward.svg' fill/></div></div>
                        </div>
                        </div>
                    </div>
                  
                ))
                }
                </div>

            </div> */}

            <div className={styles.other_components}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>
            <div className={styles.other_components}>{
                mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
            }</div>
            <div style={{ margin: mobileView ? "0 3rem" : "0 5rem" }}><TrustFactor /></div>
            <div>{
                mobileView ?
                    <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"Frequently Asked Questions"} />
                    :
                    <FrequentQuestions FaqTableData={faqs} heading={"Frequently Asked Questions"} />
            }</div>
        </>
    )
}


export default CocoCart
